import { render, staticRenderFns } from "./addMusic.vue?vue&type=template&id=d2b91918&scoped=true"
import script from "./addMusic.vue?vue&type=script&lang=js"
export * from "./addMusic.vue?vue&type=script&lang=js"
import style0 from "./addMusic.vue?vue&type=style&index=0&id=d2b91918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b91918",
  null
  
)

export default component.exports